import React, { FC } from 'react';
import Search from '@/components/ui/Search';

interface IProps {
  search: string;
  setSearch: (search: string) => void;
}

const SearchFilter: FC<IProps> = ({ search, setSearch }) => {
  return <Search placeholder="Search" value={search} onChange={setSearch} />;
};

export default SearchFilter;
